/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { colors } from "@farmlands/mui-theme";
import React from "react";

import { MaterialSymbol } from "../../../components/MaterialSymbol";
import { SEED_MIX_TYPE } from "../types/SeedOrderFormType";

const MixTypeIcon = ({ type }: { type: string | undefined }) => {
  if (!type) {
    return null;
  }

  const iconType = type === SEED_MIX_TYPE.CUSTOM ? "wysiwyg" : "inventory_2";

  return (
    <MaterialSymbol sx={{ marginRight: "8px", color: colors.primary500 }}>
      {iconType}
    </MaterialSymbol>
  );
};

export default MixTypeIcon;
